import {
  JumpStartQuizQuestion,
  QuestionType,
} from '../jumpstart-communicator/jumpstart-communicator.types';

export const questions: JumpStartQuizQuestion[] = [
  {
    id: 'c4a2b7d1-714e-4535-9964-2a5ccd03f188',
    question: 'Why is teamwork important in both life and work?',
    options: [
      {
        id: '84c60adc-993e-4609-859d-d9bcb1ead153',
        option: 'It helps people achieve more together than they could alone.',
      },
      {
        id: '2901d00e-e821-47b3-b106-efa232b4a85b',
        option: 'It allows everyone to avoid responsibility.',
      },
      {
        id: 'e5d93116-26af-4102-8b14-f182b222c974',
        option: 'It ensures everyone gets the same tasks.',
      },
      {
        id: '1912b46c-9ae7-4976-98b7-ac3df2a25d72',
        option: 'It makes people compete against each other.',
      },
    ],
    answers: ['84c60adc-993e-4609-859d-d9bcb1ead153'],
    answer_description:
      'Teamwork is important in both life and work as it helps people achieve more together than they could alone.',
    wrong_answer_description:
      'Teamwork is important in both life and work as it helps people achieve more together than they could alone.',
    type: QuestionType.CHECKBOX,
  },
  {
    id: '563d50b6-2c35-429c-857a-5328c2a131bb',
    question: 'What are the benefits of being able to collaborate with others?',
    options: [
      {
        id: 'd827df78-8107-4926-acf5-d10a0f5a3478',
        option: 'Solving problems more easily and sharing the workload.',
      },
      {
        id: '01904630-254e-41a4-98f3-b357ce1ffa71',
        option: 'Having to do everything by yourself.',
      },
      {
        id: 'c5ef7e16-e19a-49a6-81fd-f0e88ff223cb',
        option: 'Avoiding any disagreements or conflicts.',
      },
      {
        id: '73692c9d-d42a-44f5-82e3-c09ee973b909',
        option: 'Ensuring everyone works independently.',
      },
    ],
    answers: ['d827df78-8107-4926-acf5-d10a0f5a3478'],
    answer_description:
      'The benefits of being able to collaborate with others include solving problems and sharing the workload.',
    wrong_answer_description:
      'The benefits of being able to collaborate with others include solving problems and sharing the workload.',
    type: QuestionType.RADIO,
  },
  {
    id: '42bf4e28-2c0c-4167-a2e6-85a2ce7af4af',

    question: 'What does the LOVE framework stand for in building trusted relationships?',
    options: [
      {
        id: '31b59720-83a2-49d3-8406-1c0014b0f660',
        option: 'Listen, Oversee, Validate, Encourage',
      },
      {
        id: 'rf08b684-d1ae-4b28-856a-24061a6067ec',
        option: 'Lean in and Listen, Open Posture, Validate, Elevate',
      },
      { id: '0f08b684-d1ae-4b28-856a-24061a6067ec', option: 'Look, Observe, Verify, Execute' },
      { id: '1f08b684-d1ae-4b28-856a-24061a6067ec', option: 'Learn, Offer, Value, Engage' },
    ],
    answers: ['rf08b684-d1ae-4b28-856a-24061a6067ec'],
    answer_description:
      'The LOVE framework stands for lean in and listen, open posture, validate, and elevate.',
    wrong_answer_description:
      'The LOVE framework stands for lean in and listen, open posture, validate, and elevate.',
    type: QuestionType.RADIO,
  },
  {
    id: '27581683-6108-4004-vb1c-0397ca3eae03',

    question: 'Which type of trust is based on the belief in someone´s skills and abilities?',
    options: [
      {
        id: 'na3c6ac1-b477-4513-bb12-a752e1390da5',
        option: 'Emotional trust',
      },
      {
        id: '14bf2502-0443-4637-9554-64289c86e304',
        option: 'Integrity-based trust',
      },
      {
        id: '639a651b-75c0-421c-bc51-1c3d800e10ed',
        option: 'Competence-based trust',
      },
      {
        id: '97ee97721-c86f-40b0-84ed-7c25ea008fc7',
        option: 'Reliance trust',
      },
    ],
    answers: ['639a651b-75c0-421c-bc51-1c3d800e10ed'],
    answer_description:
      'The type of trust that is based on the belief in someone´s skills and abilities is competence-based trust.',
    wrong_answer_description:
      'The type of trust that is based on the belief in someone´s skills and abilities is competence-based trust',
    type: QuestionType.CHECKBOX,
  },
  {
    id: '8g5ab076-74bf-4bd7-8880-f96655eb7ab1',
    question: 'What is psychological safety in a team setting?',
    options: [
      {
        id: '916c731b-a108-44ba-b3d1-6a9f4356b299',
        option: ' Ensuring physical safety during tasks',
      },
      {
        id: 'fk463516-11ac-4c75-8b1d-ab0e199fb361',
        option: 'Feeling that one can speak freely without fear of judgment or criticism',
      },
      {
        id: '6307cf08-a16e-4570-91fe-a136d42acfac',
        option: 'Having a quiet and calm work environment',
      },
      {
        id: '4jk660e2-8c55-4ed8-9dcd-a59cadae39e7',
        option: 'Having strict rules and regulations to follow',
      },
    ],
    answers: ['fk463516-11ac-4c75-8b1d-ab0e199fb361'],
    answer_description:
      'Psychological safety in a team setting is feeling that one can speak freely without fear of judgment or criticism.',
    wrong_answer_description:
      'Psychological safety in a team setting is feeling that one can speak freely without fear of judgment or criticism.',
    type: QuestionType.RADIO,
  },
  {
    id: '871be5a0-c8cf-41b8-bb66-f080208b0aad',
    question: 'Which of the following practices can help cultivate psychological safety?',
    options: [
      { id: '4893487d-01ad-48b0-89a5-1954cb7a00fa', option: 'Ignoring mistakes' },
      { id: 'j1bf5377-c1d5-4e34-a1e3-2fb1fa4647d0', option: 'Encouraging secrecy' },
      {
        id: '37dfbadc-99d2-495e-8a4c-00b465b12bf7',
        option: 'Admitting errors and embracing curiosity',
      },
      { id: '8c96aa1b-3f2e-4e71-ba91-dbb2829c7ec6', option: 'Setting strict performance targets' },
    ],
    answers: ['37dfbadc-99d2-495e-8a4c-00b465b12bf7'],
    answer_description:
      'Admitting errors and embracing curiosity can help cultivate psychological safety.',
    wrong_answer_description:
      'Admitting errors and embracing curiosity can help cultivate psychological safety.',
    type: QuestionType.RADIO,
  },
  {
    id: '9ab86b3d-08fd-42f7-a158-42644cc6b186',
    question: 'What is team culture?',
    options: [
      {
        id: '6c7cb050-e4c6-4232-8d93-052885954bd5',
        option: 'The hierarchical structure of a team',
      },
      {
        id: '97b38e96-7e6b-44b3-9231-0c389c60397m',
        option: 'The shared values, behaviors, and traditions that shape a team´s overall vibe',
      },
      {
        id: '8c7c57e9-e77e-4e35-87a1-096c93d2a7cv',
        option: 'The individual achievements of team members',
      },
      {
        id: '694eba78-9fb0-43e4-9724-4e5ab842b1ah',
        option: 'The physical environment where the team works',
      },
    ],
    answers: ['97b38e96-7e6b-44b3-9231-0c389c60397m'],
    answer_description:
      'Team culture is the shared values, behaviors, and traditions that shape a team´s overall vibe.',
    wrong_answer_description:
      'Team culture is the shared values, behaviors, and traditions that shape a team´s overall vibe.',
    type: QuestionType.RADIO,
  },
  {
    id: '8d97ae79-8111-416d-88d3-2df5d53dc9ae',
    question: 'Which component is NOT part of creating a positive team culture?',
    options: [
      {
        id: '9b27dcdb-3e5c-4263-bb59-8f780fb3cd7f',
        option: 'Values and beliefs',
      },
      {
        id: 'p69c036b-e130-4533-a732-f7ccb68a4bn7',
        option: 'Behavior and norms',
      },
      {
        id: '5d619f2a-3a38-4d12-b0e4-41710f9f947a',
        option: 'Individual competitiveness',
      },
      {
        id: '9f2a3fa5-730f-4fa0-85b8-542ea451a6ec',
        option: 'Leadership style',
      },
    ],
    answers: ['5d619f2a-3a38-4d12-b0e4-41710f9f947a'],
    answer_description:
      'Individual competitiveness is not a part of creating a positive team culture.',
    wrong_answer_description:
      'Individual competitiveness is not a part of creating a positive team culture.',
    type: QuestionType.RADIO,
  },
  {
    id: '9h2354c1-d25a-4b33-88fd-84913588edfb',
    question: 'Which of the following is a strategy to develop a solution-oriented mindset?',
    options: [
      {
        id: '2986e2d8-49da-442d-9f30-57f743c5c42e',
        option: 'Ignoring problems until they go away',
      },
      {
        id: '1pa9f582-9ef6-40bc-8231-77b93a5cb621',
        option: 'Focusing solely on identifying problems',
      },
      {
        id: '95kfc0f3-bec8-485f-acb7-6be43ee72eeb',
        option: 'Reframing problems as opportunities and asking curious questions',
      },
      {
        id: '4a83fe4d-2c36-40bb-abfd-3e4d7c203808',
        option: 'Blaming others for mistakes',
      },
    ],
    answers: ['95kfc0f3-bec8-485f-acb7-6be43ee72eeb'],
    answer_description:
      'Reframing problems as opportunities and asking curious questions is a strategy to develop a solution-oriented mindset.',
    wrong_answer_description:
      'Reframing problems as opportunities and asking curious questions is a strategy to develop a solution-oriented mindset.',
    type: QuestionType.RADIO,
  },
  {
    id: 'see4d0ba-6781-46ab-bf85-87ccb12dec46',
    question: 'Why is conducting a post-mortem review important after a project?',
    options: [
      {
        id: '58618929-1c08-4923-9793-ae2099f56696',
        option: 'To blame team members for failures',
      },
      {
        id: '337865f3-932a-4828-afe3-75389da6b1cc',
        option: 'To celebrate successes without reflection',
      },
      {
        id: 'as530065-3f6d-4370-9717-70dca663171c',
        option: 'To understand what went well and what didn´t, and identify areas for improvement',
      },
      {
        id: 'lkh39fa5-fa41-48d4-8c7c-2b3e263feed9',
        option: 'To archive project documents',
      },
    ],
    answers: ['as530065-3f6d-4370-9717-70dca663171c'],
    answer_description:
      'Conducting a post-mortem review is important after a project to understand what went well and what didn´t, and identify areas for improvement.',
    wrong_answer_description:
      'Conducting a post-mortem review is important after a project to understand what went well and what didn´t, and identify areas for improvement.',
    type: QuestionType.RADIO,
  },
  {
    id: 'l31dd8e4-1e31-4574-92df-e79a22df0a8d',
    question: 'What is `groupthink´?',
    options: [
      {
        id: '8b81c582-608c-4fcd-a515-6a85ed74d86d',
        option: 'Making decisions based on individual ideas',
      },
      {
        id: 'j408024b-afde-4be2-9386-e0e0ed371c5c',
        option:
          'A situation where everyone in a team thinks the same way and doesn´t question the plan',
      },
      {
        id: 'k2bd5da2-e0b5-482b-840f-7c251d00601f',
        option: 'A collaborative brainstorming session',
      },
      {
        id: 'ze053c04-7a39-4761-afb2-8bbb1a649c1e',
        option: 'A team exercise to build rapport',
      },
    ],
    answers: ['j408024b-afde-4be2-9386-e0e0ed371c5c'],
    answer_description:
      'Groupthink is a situation where everyone in a team thinks the same way and doesn´t question the plan.',
    wrong_answer_description:
      'Groupthink is a situation where everyone in a team thinks the same way and doesn´t question the plan.',
    type: QuestionType.RADIO,
  },
  {
    id: 'q31dd8e4-1e31-4574-92df-t79a22df0a8i',
    question: 'How can you avoid `risky shift´ in a team?',
    options: [
      {
        id: 'ab81c582-608c-4fcd-a515-6a85ed74d86d',
        option: 'Encourage individual accountability and careful decision-making',
      },
      {
        id: 'p408024b-afde-4be2-9386-e0e0ed371c5c',
        option: 'Promote group consensus without discussion',
      },
      {
        id: '33bd5da2-e0b5-482b-840f-7c251d00601f',
        option: 'Avoid assigning any responsibilities',
      },
      {
        id: '76053c04-7a39-4761-afb2-8bbb1a649c1e',
        option: 'Make decisions based on the loudest voice',
      },
    ],
    answers: ['ab81c582-608c-4fcd-a515-6a85ed74d86d'],
    answer_description:
      'Avoid `risky shift´ in a team by encouraging individual accountability and careful decision-making.',
    wrong_answer_description:
      'Avoid `risky shift´ in a team by encouraging individual accountability and careful decision-making.',
    type: QuestionType.RADIO,
  },
  {
    id: 'sd1dd8e4-1e31-4574-92df-t79a22df0a8p',
    question: 'What is the first step in creating a Team Player Roadmap?',
    options: [
      {
        id: 'efszc582-608c-4fcd-a515-6a85ed74d86d',
        option: 'Plan',
      },
      {
        id: 'xpvjzp-afde-4be2-9386-e0e0ed371c5c',
        option: 'Identify',
      },
      {
        id: 'oias9-e0b5-482b-840f-7c251d00601f',
        option: 'Define',
      },
      {
        id: '23niao-7a39-4761-afb2-8bbb1a649c1e',
        option: 'Communicate',
      },
    ],
    answers: ['oias9-e0b5-482b-840f-7c251d00601f'],
    answer_description: 'Define is the first step in creating a Team Player Roadmap.',
    wrong_answer_description: 'Define is the first step in creating a Team Player Roadmap.',
    type: QuestionType.RADIO,
  },
  {
    id: 'yd1dd8e4-1e31-4574-92df-t79a22df5a8p',
    question: 'Why is it important to seek feedback from others in your team?',
    options: [
      {
        id: 'zfszc582-608c-4fcd-a515-6a85ed74d86n',
        option: 'To ensure everyone agrees with your perspective',
      },
      {
        id: 'bpvjzp-afde-4be2-9386-e0e0ed371c5c',
        option: 'To validate your own ideas without change',
      },
      {
        id: 'ooakd9-e0b5-482b-840f-7c251d00601f',
        option: 'To use their input as a guide for improvement and enhance team collaboration',
      },
      {
        id: 'co9732-7a39-4761-afb2-8bbb1a649c1e',
        option: 'To criticize their performance',
      },
    ],
    answers: ['ooakd9-e0b5-482b-840f-7c251d00601f'],
    answer_description:
      'It´s important to seek feedback from others in your team to use their input as a guide for improvement and enhance team collaboration.',
    wrong_answer_description:
      'It´s important to seek feedback from others in your team to use their input as a guide for improvement and enhance team collaboration.',
    type: QuestionType.RADIO,
  },
  {
    id: 'mn1dd8e4-1e31-4574-92df-t79a22df5a8p',
    question:
      'Scenario: You´re part of a group project where the team is considering taking a big risk to meet a tight deadline. What might contribute to the team´s decision to take this risk?',
    options: [
      {
        id: 'cz976z-608c-4fcd-a515-6a85ed74d86n',
        option: 'Each team member carefully weighs the pros and cons before deciding.',
      },
      {
        id: 'qwe346-afde-4be2-9386-e0e0ed371c5c',
        option: 'Team members feel less accountable for the decision if it goes wrong.',
      },
      {
        id: 'ouygh67-e0b5-482b-840f-7c251d00601f',
        option: 'Team members are overly cautious and hesitant to take risks.',
      },
      {
        id: 'fg875-7a39-4761-afb2-8bbb1a649c1e',
        option: 'The team leader takes full responsibility for all decisions made.',
      },
    ],
    answers: ['qwe346-afde-4be2-9386-e0e0ed371c5c'],
    answer_description:
      'Team members feel less accountable for the decision if it goes wrong might contribute to the team´s decision to take this risk. Known as risky-shift.',
    wrong_answer_description:
      'Team members feel less accountable for the decision if it goes wrong might contribute to the team´s decision to take this risk. Known as risky-shift.',
    type: QuestionType.RADIO,
  },
  {
    id: '12knka-1e31-4574-92df-t79a22df5a8p',
    question:
      'Scenario: During a brainstorming session, everyone seems to agree on a particular approach to solve a problem. What might be a sign that groupthink is occurring?',
    options: [
      {
        id: '234ona-608c-4fcd-a515-6a85ed74d86n',
        option: 'Team members respectfully challenge each other´s ideas.',
      },
      {
        id: 'vdf450-afde-4be2-9386-e0e0ed371c5c',
        option: 'The team leader dominates the conversation and dismisses dissenting opinions.',
      },
      {
        id: 'bdfgte-e0b5-482b-840f-7c251d00601f',
        option: 'Team members encourage open discussion and welcome diverse viewpoints.',
      },
      {
        id: 'wer46-7a39-4761-afb2-8bbb1a649c1e',
        option: 'No one questions the proposed plan, assuming everyone else agrees.',
      },
    ],
    answers: ['wer46-7a39-4761-afb2-8bbb1a649c1e'],
    answer_description:
      'A sign that groupthink is occurring is when no one questions the proposed plan, assuming everyone else agrees.',
    wrong_answer_description:
      'A sign that groupthink is occurring is when no one questions the proposed plan, assuming everyone else agrees.',
    type: QuestionType.RADIO,
  },
  {
    id: 'qwh64-1e31-4574-92df-t79a22df5a8p',
    question:
      'Scenario: Your team is about to finalize a major decision, but one member has been unusually quiet throughout the discussion. What could be a proactive step to prevent groupthink?',
    options: [
      {
        id: 'a6d53-608c-4fcd-a515-6a85ed74d86n',
        option: 'Proceed with the decision since silence indicates agreement.',
      },
      {
        id: 'a452fa-afde-4be2-9386-e0e0ed371c5c',
        option: 'Invite the quiet member to share any concerns or alternative perspectives.',
      },
      {
        id: 'drfgr33-e0b5-482b-840f-7c251d00601f',
        option:
          'Ignore the quiet member´s input as they likely have nothing valuable to contribute.',
      },
      {
        id: 'zxf34-7a39-4761-afb2-8bbb1a649c1e',
        option: 'Disband the team and start over with new members who are more vocal.',
      },
    ],
    answers: ['a452fa-afde-4be2-9386-e0e0ed371c5c'],
    answer_description:
      'A proactive step to prevent groupthink is to invite the quiet member to share any concerns or alternative perspectives.',
    wrong_answer_description:
      'A proactive step to prevent groupthink is to invite the quiet member to share any concerns or alternative perspectives.',
    type: QuestionType.RADIO,
  },
];
